<template>
  <div id="notify" class="popup notify">
    <div class="popup__container">
      <!-- Popup Controls Start -->
      <div class="popup__controls d-flex justify-content-end">
        <a
          href="#0"
          id="notify-close"
          class="popup-close hover-gradient hover-gradient-s"
        >
          <em></em>
          <span></span>
        </a>
      </div>
      <!-- Popup Controls End -->

      <!-- Popup Content Start -->
      <div class="popup__content block-rounded-l">
        <!-- Notify Popup Title Start -->
        <div class="popup-title">
          <p class="popup-title__title">Get to know about our launch</p>
          <p class="popup-title__text">
            Subscribe to our newsletter and we will send you a notification
            about the launch of our brand new site
          </p>
        </div>
        <!-- Notify Popup Title End -->

        <!-- Notify Form Container Start -->
        <div class="form-container">
          <!-- Reply Messages Start-->
          <div class="reply-group subscription-ok">
            <i class="fa-solid fa-circle-check reply-group__icon"></i>
            <p class="reply-group__title txt-light">Done!</p>
            <span class="reply-group__text"
              >Thanks for subscribing. We will send you a notification about our
              launch.</span
            >
          </div>
          <div class="reply-group subscription-error">
            <i class="fa-solid fa-face-frown-open reply-group__icon"></i>
            <p class="reply-group__title">Ooops!</p>
            <span class="reply-group__text"
              >Something went wrong. Please try again later.</span
            >
          </div>
          <!-- Reply Messages End-->

          <!-- Notify Contact Form Start-->
          <form class="form notify-form form-light">
            <input
              class="block-rounded-s"
              type="email"
              placeholder="Your Email"
              required
            />
            <button
              class="btn btn-l btn-light hover-gradient hover-gradient-l"
              type="submit"
            >
              <em></em>
              <span class="btn-caption">Submit</span>
            </button>
          </form>
          <!-- Notify Contact Form End-->
        </div>
        <!-- Notify Form Container End -->
      </div>
      <!-- Popup Content End -->
    </div>
  </div>
</template>

<script>
export default {
  name: "NotifyComponent",
};
</script>